<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog"
      content-class="campaignProductDialog"
      persistent max-width="730">      
      <v-card
        style="max-height: 100%;"
      >
        <v-card-title class="headline">
          <h1>{{ isTicket ? "Novo Ticket / Cota" : "Novo Produto" }}</h1>
          <v-btn class="close-modal" @click="closeModal">
            <i class="fal fa-times"></i>
          </v-btn>
        </v-card-title>
        <v-card-text style="flex: 0;">
          <v-flex flex-column>
            <v-layout pa-3>
              <v-flex xs5 pr-3>
                <div class="upload-image" id="previewProductImage" ref="previewProductImage">
                  <label for="upload-activity">
                    <i class="fas fa-camera-alt"></i>
                  </label>
                  <label
                    for="upload-activity"
                    class="do-upload"
                    v-show="campaignProduct.file.path == ''"
                  >
                    <i class="fal fa-cloud-upload"></i>Faça Upload
                  </label>
                  <input
                    type="file"
                    id="upload-activity"
                    accept="image/*"
                    @change="productFileChanged"
                    ref="upload_activity"
                  />
                </div>
              </v-flex>
              <!-- TICKET -->
              <template v-if="isTicket">
                <v-flex xs7>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <InputText
                        ref="nameInput"
                        type="text"
                        place-holder="Dê um nome para este produto"
                        textLabel="Nome do produto"
                        v-model="campaignProduct.name"
                        invalidInputMessage="Preencha o nome do produto"
                        labelCharLimit="50"
                      />
                    </v-flex>
                    <v-flex xs12>
                      <v-checkbox
                        v-model="campaignProduct.openValue"
                        :label="`Produto de valor aberto`"
                        @change="changeOpenValue"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs12>
                      <v-checkbox
                        v-model="campaignProduct.openTickets"
                        :label="`Produto com tickets ilimitados`"
                        @change="changeOpenTickets"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs6 pr-2 v-if="showValue">
                      <InputMoney
                        ref="fixedValueInput"
                        type="tel"
                        v-model="campaignProduct.fixedValue"
                        :precision="2"
                        textLabel="Valor"
                        :infoVisible="false"
                        invalidInputMessage="Preencha o valor"
                      />
                    </v-flex>
                    <v-flex xs6 v-if="showTicketsQtde">
                      <InputText
                        ref="availableTicketsQuantityInput"
                        v-model.number="campaignProduct.availableTicketsQuantity"
                        type="tel"
                        place-holder="340"
                        textLabel="Ingressos disponíveis"
                        invalidInputMessage="Preencha a quantidade disponível"
                        mask="#########"
                      />
                    </v-flex>

                    <!-- Só aparece quando a campanha distribui números da sorte por
                         faixa. Vazio ou zero: esta faixa não dá número nenhum. -->
                    <v-flex xs6 v-if="drawByProduct">
                      <InputText
                        ref="numberDrawQuantityInput"
                        :required="false"
                        v-model.number="campaignProduct.numberDrawQuantity"
                        type="tel"
                        place-holder="10"
                        textLabel="Números da sorte desta faixa"
                        helpLabel="Deixe vazio para esta faixa não dar números."
                        mask="#####"
                      />
                    </v-flex>
                    <v-flex xs12>
                      <InputDateRange
                        ref="initialFinalDateInput"
                        textLabel="Data/Período"
                        place-holder="Selecione"
                        v-model="campaignProduct.initialFinalDates"
                        :monthsToShow="3"
                        :allowSingleDate="true"
                        invalidInputMessage="Preencha o intervalo de datas"
                      ></InputDateRange>
                    </v-flex>
                    <div class="txtarea-labels input-comp">
                      <label>Observações</label>
                      <InputTextArea
                        ref="descriptionInput"
                        rows="2"
                        v-model="campaignProduct.description"
                        place-holder="Escreva sobre esta atividade do projeto"
                        invalidInputMessage="Preencha a descrição da faixa"
                        labelAreaCharLimit="1000"
                      ></InputTextArea>
                    </div>
                    <div class="txtarea-labels input-comp">
                      <label>Regras e Condições</label>
                      <InputTextArea
                        ref="rulesAndConditionsInput"
                        rows="2"
                        v-model="campaignProduct.rulesAndConditions"
                        place-holder="Escreva sobre as regras e condições"
                        invalidInputMessage="Preencha as regras e condições"
                      ></InputTextArea>
                    </div>
                    <div class="txtarea-labels input-comp">
                      <label>
                        Url Customizada
                        <br />
                        Exemplo: {{ "*.abraceumacausa.com.br/carrinho?product=" + campaignProduct.customUrl }}
                      </label>
                      <InputTextArea
                        rows="1"
                        :maxlength="40"
                        v-model="campaignProduct.customUrl"
                        place-holder="Valor para a url customizada sem espaços em branco"
                        invalidInputMessage="Valor para a url customizada"
                      ></InputTextArea>
                    </div>
                  </v-layout>
                  <div class="txtarea-labels input-comp"></div>
                </v-flex>
              </template>
              <!-- PRODUTO DE DOAÇÃO -->
              <template v-else>
                <v-flex xs7>
                  <InputText
                    ref="nameInput"
                    v-model="campaignProduct.name"
                    type="text"
                    place-holder="Dê um nome para este produto"
                    textLabel="Nome do produto"
                    invalidInputMessage="Preencha o nome do produto"
                    labelCharLimit="50"
                  />
                  <InputMoney
                    ref="initialPriceInput"
                    v-model="campaignProduct.initialValue"
                    :precision="2"
                    textLabel="Valor mínimo do produto"
                    invalidInputMessage="preencha o valor mínimo do produto"
                  />
                  <InputMoney
                    ref="finalPriceInput"
                    v-model="campaignProduct.finalValue"
                    textLabel="Valor máximo do produto"
                    invalidInputMessage="preencha o valor máximo do produto"
                    :precision="2"
                  />
                  <v-layout>
                    <v-flex xs12 pr-2>
                      <InputText
                        ref="suggestionValueInput"
                        v-model="campaignProduct.suggestionValue"
                        type="text"
                        place-holder="Dê um valor para este produto"
                        textLabel="Valor sugerido (Coloque R$ antes de valores) - Opcional"
                        helpLabel="Ex: de R$20 a R$40"
                        :required="false"
                      />
                    </v-flex>
                  </v-layout>

                  <!-- Só aparece quando a campanha distribui números da sorte por
                       faixa. Vazio ou zero: esta faixa não dá número nenhum. -->
                  <v-layout v-if="drawByProduct">
                    <v-flex xs12 pr-2>
                      <InputText
                        ref="numberDrawQuantityInput"
                        :required="false"
                        v-model.number="campaignProduct.numberDrawQuantity"
                        type="tel"
                        place-holder="10"
                        textLabel="Números da sorte desta faixa"
                        helpLabel="Deixe vazio para esta faixa não dar números."
                        mask="#####"
                      />
                    </v-flex>
                  </v-layout>
                  <div class="txtarea-labels input-comp">
                    <label>Descrição</label>
                    <InputTextArea
                      ref="descriptionInput"
                      v-model="campaignProduct.description"
                      rows="2"
                      invalidInputMessage="Preencha a descrição da faixa"
                      labelAreaCharLimit="250"
                    ></InputTextArea>
                  </div>
                  <div class="txtarea-labels input-comp">
                    <label>
                      Url Customizada
                      <br />
                      Exemplo: {{ "*.abraceumacausa.com.br/carrinho?product=" + campaignProduct.customUrl }}
                    </label>
                    <InputTextArea
                      rows="1"
                      :maxlength="40"
                      v-model="campaignProduct.customUrl"
                      place-holder="Valor para a url customizada sem espaços em branco"
                      invalidInputMessage="Valor para a url customizada"
                    ></InputTextArea>
                  </div>
                </v-flex>
              </template>
            </v-layout>
            <v-layout pa-3 d-flex flex-column>
              <v-layout xs12 md12 align-center>
                <v-flex xs1>
                  <v-switch label v-model="campaignProduct.showQuestions" class="ma-0"></v-switch>
                </v-flex>
                <h3 class="title-category">Especificações</h3>
              </v-layout>
              <transition name="slide-fade" mode="out-in">
                <v-layout d-flex flex-column v-if="campaignProduct.showQuestions">
                  <div
                    v-for="(campaignProductQuestion, index) in campaignProduct.campaignProductQuestionList.filter((x) => x.active == true)"
                    :key="campaignProductQuestion.Order"
                  >
                    <v-layout xs12 pr-2 align-center>
                      <!-- <v-flex xs6> -->
                      <v-flex xs11>
                        <InputText
                          ref="questionInput"
                          v-model="campaignProductQuestion.question"
                          type="text"
                          place-holder="Etiqueta da especificação"
                          textLabel="Etiqueta"
                          :required="false"
                        />
                      </v-flex>
                      <!-- <v-flex xs5 pl-2>
                        <InputSelect
                          :items="answerType"
                          textLabel="Tipo de resposta"
                          valueAttribute="id"
                          textAttribute="name"
                        ></InputSelect>
                      </v-flex>-->
                      <v-flex xs1 pt-4 class="d-flex flex-row">
                        <a
                          @click="addQuestion()"
                          v-if="index == campaignProduct.campaignProductQuestionList.length - 1"
                        >
                          <Icon
                            name="fal fa-plus-circle justify-end d-flex"
                            size="24"
                            class="ml-2"
                            colorFont="#C3C6D5"
                          />
                        </a>
                        <a @click="removeQuestion(index)">
                          <Icon
                            name="fal fa-trash justify-end d-flex"
                            size="24"
                            class="ml-2"
                            colorFont="#C3C6D5"
                          />
                        </a>
                      </v-flex>
                    </v-layout>
                    <v-layout xs12 md12 align-center>
                      <v-switch
                        label="Alternativas"
                        v-model="campaignProductQuestion.hasAlternatives"
                        class="ma-0"
                        @change="changeSwitchAlternatives(campaignProductQuestion)"
                      ></v-switch>
                    </v-layout>
                    <v-layout pr-4 flex-wrap v-if="campaignProductQuestion.hasAlternatives">
                      <v-layout
                        v-for="(alternative, index) in campaignProductQuestion.campaignProductQuestionAlternatives"
                        :key="alternative.id"
                        xs12
                        md6
                        lg4
                        pr-2
                        align-center
                        class="flex"
                      >
                        <v-flex xs10>
                          <InputText
                            ref="alternativeInput"
                            v-model="alternative.description"
                            type="text"
                            place-holder="Etiqueta da especificação"
                            textLabel="Etiqueta"
                            :required="false"
                          />
                        </v-flex>
                        <v-flex xs2 pt-4 class="d-flex flex-row">
                          <a
                            v-if="index == campaignProductQuestion.campaignProductQuestionAlternatives.length - 1"
                            @click="addAlternative(campaignProductQuestion)"
                          >
                            <Icon
                              name="fal fa-plus-circle justify-center d-flex"
                              size="20"
                              colorFont="#C3C6D5"
                            />
                          </a>
                          <a @click="removeAlternative(index, campaignProductQuestion)">
                            <Icon
                              name="fal fa-trash justify-center d-flex"
                              size="20"
                              colorFont="#C3C6D5"
                            />
                          </a>
                        </v-flex>
                      </v-layout>
                    </v-layout>
                  </div>
                  <!-- <v-layout xs12 pr-2 align-center>
                    <v-flex xs2>
                      <InputText
                        type="text"
                        place-holder="Ex: P"
                        textLabel="Opções"
                        :required="false"
                      />
                    </v-flex>
                    <v-flex xs2>
                      <InputText
                        type="text"
                        :required="false"
                        class="pl-2"
                        style="padding-top: 20px"
                      />
                    </v-flex>
                    <v-flex xs2>
                      <InputText
                        type="text"
                        :required="false"
                        class="pl-2"
                        style="padding-top: 20px"
                      />
                    </v-flex>
                    <v-flex xs2>
                      <InputText
                        type="text"
                        :required="false"
                        class="pl-2"
                        style="padding-top: 20px"
                      />
                    </v-flex>
                    <v-flex xs2>
                      <InputText
                        type="text"
                        :required="false"
                        class="pl-2"
                        style="padding-top: 20px"
                      />
                    </v-flex>
                    <v-flex xs2>
                      <InputText
                        type="text"
                        :required="false"
                        class="pl-2"
                        style="padding-top: 20px"
                      />
                    </v-flex>
                    <v-flex xs2>
                      <InputText
                        type="text"
                        :required="false"
                        class="pl-2"
                        style="padding-top: 20px"
                      />
                    </v-flex>
                  </v-layout>-->
                </v-layout>
              </transition>
            </v-layout>
          </v-flex>
        </v-card-text>
        <v-card-actions class="pa-0">
          <div class="footer-modal-atividades">
            <v-btn
              flat
              round
              color="white"
              class="btn btn-default px-5"
              large
              @click="closeModal"
            >Cancelar</v-btn>
            <v-btn
              flat
              round
              color="white"
              class="btn btn-primary px-5"
              large
              @click="isValid"
            >Salvar</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script type="plain/text">
import CampaignProduct from "@/scripts/models/campaignProduct.model";
import CampaignProductQuestion from "@/scripts/models/campaignProductQuestion.model";
import CampaignProductQuestionAlternatives from "@/scripts/models/campaignProductQuestionAlternatives.model";
import ValidatableComponent from "@/components/base/ValidatableComponent.vue";
import { GetCurrentOrder } from "@/scripts/helpers/list.helper";
import CampaignService from "@/scripts/services/campaign.service";
import CommonHelper from "@/scripts/helpers/common.helper";
import FileService from "@/scripts/services/file.service.js";

// VUEX
import { mapGetters, mapActions } from "vuex";

export default {
  extends: ValidatableComponent,
  props: ["campaignId", "isTicket", "dialog", "toEdit", "drawByProduct"],
  data() {
    return {
      CommonHelper: CommonHelper,
      showValue: true,
      showTicketsQtde: true,
      campaignService: new CampaignService(),
      campaignProduct: new CampaignProduct(),
      fileService: new FileService(),
      campaignProductList: this.value,
      originalCampaignProduct: {},
      validCustomUrl: true,
      answerType: [
        {
          id: 1,
          name: "Checkbox",
        },
        {
          id: 2,
          name: "Radio",
        },
      ],
    };
  },
  watch: {
    "campaignProduct.showQuestions": {
      handler: function (after) {
        if (after && this.campaignProduct.campaignProductQuestionList.length == 0) {
          let campaignProductQuestion = new CampaignProductQuestion();

          campaignProductQuestion.campaignProductQuestionAlternatives.push(new CampaignProductQuestionAlternatives());

          this.campaignProduct.campaignProductQuestionList.push(campaignProductQuestion);
        }
      },
      deep: true,
    },
  },
  created() {
    this.onValidationSuccessMethod = this.validationSuccess;
    this.validationMethod = this.validate;
  },
  mounted() {
    if (this.toEdit) this.addToEdit(this.toEdit)
  },
  methods: {
    ...mapActions([
      'refreshCampaignProducts'
    ]),
    changeOpenValue(value) {
      this.showValue = !value;
      if (!value) this.campaignProduct.fixedValue = 0;
    },
    changeOpenTickets(value) {
      this.showTicketsQtde = !value;
      if (!value) this.campaignProduct.availableTicketsQuantity = 0;
    },
    async listByCampaignId() {
      this.campaignService.listCampaignProductByCampaignId().then(data => {
        for (let product of data) {
          product.file = this.getImage(product)
        }
        this.$emit("input", data)
      });
    },
    async getImage(item) {
      this.fileService
        .getById(item.fileId).then((file) => {
          item.file = file
        })
    },
    async save() {
      if (this.campaignProduct.customUrl != null) {
        if (this.campaignProduct.customUrl.indexOf(' ') >= 0) {
          this.CommonHelper.swal("A URL customizada não pode conter espaços em branco");
          this.validCustomUrl = false;
          return;
        }
      }
      this.validCustomUrl = true;
      this.campaignProduct.campaignId = this.campaignId;
      this.campaignService.saveCampaignProduct(this.campaignProduct).then(() => {
        this.refreshCampaignProducts()
      })
    },
    changeStatus(campaignProduct, current) {
      campaignProduct.campaignId = this.campaignId;
      campaignProduct.active = current;
      this.campaignService.saveCampaignProduct(campaignProduct).then(() => {
        this.refreshList()
      });
    },
    remove(campaignProductId) {
      this.campaignService.deleteCampaignProduct(this.refreshList(), campaignProductId);
    },
    refreshList() {
      this.listByCampaignId();
     },
    changeSwitchAlternatives(campaignProductQuestion) {
      if (campaignProductQuestion.hasAlternatives && campaignProductQuestion.campaignProductQuestionAlternatives.length == 0) {
        let newAlternative = new CampaignProductQuestionAlternatives();
        campaignProductQuestion.campaignProductQuestionAlternatives.push(newAlternative);
      }
    },
    addAlternative(campaignProductQuestion) {
      let valid = true;

      for (let i = 0; i < campaignProductQuestion.campaignProductQuestionAlternatives.length; i++) {
        if (!campaignProductQuestion.campaignProductQuestionAlternatives[i].description) {
          this.$refs.alternativeInput[i].focus();
          valid = false;
        }
      }
      if (valid) {
        let newAlternative = new CampaignProductQuestionAlternatives();
        campaignProductQuestion.campaignProductQuestionAlternatives.push(newAlternative);
      }
    },
    removeAlternative(index, campaignProductQuestion) {
      campaignProductQuestion.campaignProductQuestionAlternatives.splice(index, 1);
    },
    addQuestion() {
      let valid = true;

      for (let i = 0; i < this.campaignProduct.campaignProductQuestionList.length; i++) {
        if (!this.campaignProduct.campaignProductQuestionList[i].question) {
          this.$refs.questionInput[i].focus();
          valid = false;
        }
      }

      if (valid) {
        let newQuestion = new CampaignProductQuestion();
        newQuestion.Order = GetCurrentOrder(this.campaignProduct.campaignProductQuestionList);
        newQuestion.campaignProductQuestionAlternatives.push(new CampaignProductQuestionAlternatives());
        this.campaignProduct.campaignProductQuestionList.push(newQuestion);
      }
    },
    removeQuestion(index) {
      this.campaignProduct.campaignProductQuestionList.splice(index, 1);
    },
    validate(performMethods) {      
      if (this.campaignProduct.file == null || this.campaignProduct.file.path == "") {
        this.$store.commit("SET_SNACKBAR_MESSAGE", "Escolha uma imagem para o produto");
        return false;
      }

      let valid = this.validateComponents(performMethods);
      if (!valid) return false;
      if (this.campaignProduct.showQuestions) {
        for (let i = 0; i < this.campaignProduct.campaignProductQuestionList.length; i++) {
          if (!this.campaignProduct.campaignProductQuestionList[i].question) {
            if (this.campaignProduct.campaignProductQuestionList.length == 1) {
              this.$refs.questionInput[i].focus();
              valid = false;
            } else if (i == this.campaignProduct.campaignProductQuestionList.length - 1) {
              this.removeQuestion(i);
              valid = true;
            } else {
              this.$refs.questionInput[i].focus();
              valid = false;
            }
          }
        }
      }
      return valid;
    },
    validationSuccess() {
      if (this.campaignProduct.initialValue)
      this.campaignProduct.initialValue = parseFloat(this.campaignProduct.initialValue).toFixed(2)

      if (this.campaignProduct.finalValue)
      this.campaignProduct.finalValue = parseFloat(this.campaignProduct.finalValue).toFixed(2)
    
      //this.copy(this.campaignProduct, this.originalCampaignProduct);
      this.save();
      if (this.validCustomUrl) {
        this.closeModal();
      }
    },
    closeModal() {
      this.$emit('close')
      this.copy(new CampaignProduct(), this.campaignProduct);
      this.$refs.previewProductImage.style.backgroundImage = "";
    },
    productFileChanged(event) {
      var file = event.target.files[0];
      if (file) {
        let reader = new FileReader();
        this.campaignProduct.file.name = file.name;
        reader.onload = function () {
          this.$refs.previewProductImage.style.backgroundImage = "url(" + reader.result + ")";
          this.campaignProduct.file.path = reader.result;
          this.campaignProduct.file.id = 0;
        }.bind(this);
        reader.readAsDataURL(file);
      }
    },
    addToEdit(item) {      
      this.originalCampaignProduct = item;
      this.copy(this.originalCampaignProduct, this.campaignProduct);
      this.showValue = !this.campaignProduct.openValue;
      this.showTicketsQtde = !this.campaignProduct.openTickets;
      this.$refs.previewProductImage.style.backgroundImage = "url(" + item.file.path + ")";
      this.$refs.nameInput.showValidationMessage = false;
      this.$refs.descriptionInput.showValidationMessage = false;
      if (this.isTicket) {
        this.$refs.fixedValueInput.showValidationMessage = false;
        this.$refs.availableTicketsQuantityInput.showValidationMessage = false;
        this.$refs.initialFinalDateInput.showValidationMessage = false;
        this.$refs.rulesAndConditionsInput.showValidationMessage = false;
        this.$refs.customUrlInput.showValidationMessage = false;
      } else {
        this.$refs.suggestionValueInput.showValidationMessage = false;
      }
    },
    copy(from, to) {
      to.Order = from.Order;
      to.id = from.id;
      to.name = from.name;
      to.suggestionValue = from.suggestionValue;
      to.initialValue = from.initialValue;
      to.finalValue = from.finalValue;
      to.description = from.description;
      to.showQuestions = from.showQuestions;
      to.campaignProductQuestionList = [];
      to.availableTicketsQuantity = from.availableTicketsQuantity;
      to.rulesAndConditions = from.rulesAndConditions;
      to.fixedValue = from.fixedValue;
      to.openValue = from.openValue;
      to.openTickets = from.openTickets;
      to.customUrl = from.customUrl;
      // Sem esta linha o valor gravava e sumia ao reabrir: o copy é campo a campo,
      // então propriedade que não está aqui volta com o default do model.
      to.numberDrawQuantity = from.numberDrawQuantity;
      to.initialFinalDates = [];
      if (from.initialFinalDates.length == 2) {
        to.initialDate = from.initialFinalDates[0];
        to.initialFinalDates[0] = from.initialFinalDates[0];
        if (from.initialFinalDates[1]) {
          to.finalDate = from.initialFinalDates[1];
          to.initialFinalDates[1] = from.initialFinalDates[1];
        } else {
          to.finalDate = null;
          to.initialFinalDates[1] = null;
        }
      } else {
        to.initialDate = from.initialFinalDates[0];
        to.initialFinalDates[0] = from.initialFinalDates[0];
      }
      if (from.campaignProductQuestionList)
        for (let i = 0; i < from.campaignProductQuestionList.length; i++) {
          let question = new CampaignProductQuestion();
          this.copyQuestion(from.campaignProductQuestionList[i], question);
          to.campaignProductQuestionList.push(question);
        }
      to.file.id = from.file.id;
      to.file.userId = from.file.userId;
      to.file.name = from.file.name;
      to.file.path = from.file.path;
      to.file.size = from.file.size;
      to.file.extension = from.file.extension;
      to.file.origin = from.file.origin;
    },
    copyQuestion(from, to) {
      to.Order = from.Order;
      to.id = from.id;
      to.campaignProductId = from.campaignProductId;
      to.question = from.question;
      to.hasAlternatives = from.hasAlternatives;
      to.active = from.active;
      from.campaignProductQuestionAlternatives.forEach((fromAlternative) => {
        let alternative = new CampaignProductQuestionAlternatives();
        this.copyAlternative(fromAlternative, alternative);
        to.campaignProductQuestionAlternatives.push(alternative);
      });
    },
    copyAlternative(from, to) {
      to.id = from.id;
      to.description = from.description;
    },
  },
};
</script>
